<template>
    <div>

        <vue-headful title="Inspections :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-list"></i> Inspections</li>
                <li class="ml-3" v-if="this.$root.hasPermission(['inspections.create', 'inspections.manage'])">
                    <router-link :to="`/inspections/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
                </li>
            </ol>
        </h4>

        <template v-if="$store.state.user.is_admin">
            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                <template v-for="(tab, key) in settingsTabs">
                    <b-nav-item :active="curTab === key" @click="curTab = key">
                        {{ tab }}
                    </b-nav-item>
                </template>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
              <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                <template v-for="(tab, key) in settingsTabs">
                    <b-dropdown-item :active="curTab === key" @click="curTab = key">
                        {{ tab }}
                    </b-dropdown-item>
                </template>
              </b-dropdown>
            </div>
        </template>

        <saved-filter-title :filterKey="'inspectionFilters'" />

        <div v-show="curTab === 'list'">
            <div class="card">
                <div class="card-body">
                    <div v-if="loading">
                        <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                    </div>
                    <div v-else>

                        <inspection-list ref="inspectionIndexList" :allowFilterSaving="true" :filterId="(filter_id ? parseInt(filter_id) : null)" @inspectionListCount="setInspCount" />

                    </div>
                </div>
            </div>
        </div>
        <template v-if="$store.state.user.is_admin">
            <div v-show="curTab === 'settings'">
                <div class="card">
                    <div class="card-body">
                        <email-alert-list :assetType="'Inspection'"></email-alert-list>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                filter_id: this.$route.query.filter_id,
                loading: false,
                inspCount: 0,
                curTab: 'list',
            }
        },

        computed: {
            tabButtonTitle(){
                //Send it
                return '<i class="fa fa-bars"></i> ' + this.settingsTabs[this.curTab];
            },

            settingsTabs(){
                return {
                    list: 'Inspections ('+this.inspCount+')',
                    settings: 'Email Alert Settings',
                }
            },
        },

        methods: {
            //Check for Saved Filters
            setFilterFromUrl(id){
                //Get the filter
                var filter = null;

                //Loop and locate
                for (var i = this.$store.state.user.filters.length - 1; i >= 0; i--)
                {
                    //Check the ID
                    if(parseInt(this.$store.state.user.filters[i].id) == parseInt(id))
                    {
                        filter = this.$store.state.user.filters[i];
                    }
                }

                //Set all the value - this will also set it to NULL
                this.$store.commit('setAppliedFilter', {key: 'inspectionFilters', filter: filter});

                //Refresh
                this.$refs.inspectionIndexList.refreshTableData();
            },

            setInspCount(count){
                //Send it
                this.inspCount = count;
            }
        },

        mounted(){
            //Focus on the SEarch Input
            this.$refs.inspectionIndexList.$refs.inspectionTable.$refs.genericFilter.focus();
        },
    }
</script>
